// ===== File Upload Size Validation =====
// ตรวจสอบขนาดไฟล์ฝั่ง client ก่อน submit
// ครอบคลุม: input[type="file"] และ hidden base64 จาก cropper
// ใช้คู่กับ server-side validate_and_rename_upload() / save_base64_profile() ใน function.php

const MAX_MB    = 10;
const MAX_BYTES = MAX_MB * 1024 * 1024;

function formatMB(bytes) {
  return (bytes / 1024 / 1024).toFixed(2) + ' MB';
}

// คำนวณขนาด bytes จาก base64 data URL
function base64SizeBytes(dataUrl) {
  if (!dataUrl) return 0;
  const base64 = dataUrl.split(',')[1] || '';
  // base64 ทุก 4 chars = 3 bytes หัก padding '='
  const padding = (base64.match(/=+$/) || [''])[0].length;
  return Math.floor((base64.length * 3) / 4) - padding;
}

function collectOversizedFiles(form) {
  const errors = [];

  // ตรวจ input[type="file"] ปกติ
  form.querySelectorAll('input[type="file"]').forEach(function (input) {
    Array.from(input.files).forEach(function (file) {
      if (file.size > MAX_BYTES) {
        errors.push('"' + file.name + '" ขนาด ' + formatMB(file.size) + ' (เกินขีดจำกัด ' + MAX_MB + ' MB)');
      }
    });
  });

  // ตรวจ hidden input ที่มาจาก cropper (base64 data URL)
  form.querySelectorAll('input[type="hidden"].hidden-output').forEach(function (hidden) {
    const val = hidden.value || '';
    if (!val.startsWith('data:image/')) return;
    const sizeBytes = base64SizeBytes(val);
    if (sizeBytes > MAX_BYTES) {
      errors.push('รูปที่ครอป ขนาด ' + formatMB(sizeBytes) + ' (เกินขีดจำกัด ' + MAX_MB + ' MB)');
    }
  });

  return errors;
}

export function initFileUploadValidation() {

  // ตรวจ input[type="file"] ทันทีที่เลือก — reset + Swal
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (input.type !== 'file') return;

    const errors = [];
    Array.from(input.files).forEach(function (file) {
      if (file.size > MAX_BYTES) {
        errors.push('"' + file.name + '" ขนาด ' + formatMB(file.size) + ' (เกินขีดจำกัด ' + MAX_MB + ' MB)');
      }
    });

    if (errors.length === 0) return;

    input.value = '';
    Swal.fire({
      title: 'ไฟล์ขนาดใหญ่เกินไป',
      html: errors.join('<br>'),
      icon: 'warning',
      confirmButtonText: 'ตกลง',
      confirmButtonColor: '#f5a623',
    });
  });

  // ตรวจ base64 cropper ทันทีที่ hidden-output ถูก set
  // cropper.js set hidden.value โดยตรง ไม่ trigger 'change' → ใช้ MutationObserver
  const cropperObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      const hidden = mutation.target;
      if (!hidden.classList.contains('hidden-output')) return;
      const val = hidden.value || '';
      if (!val.startsWith('data:image/')) return;

      const sizeBytes = base64SizeBytes(val);
      if (sizeBytes <= MAX_BYTES) return;

      hidden.value = ''; // ล้างค่า
      // ล้าง preview
      const field = hidden.closest('.field');
      if (field) {
        const box = field.querySelector('.preview-box');
        if (box) box.classList.remove('has-image');
        const preview = field.querySelector('.preview');
        if (preview) preview.src = '';
      }

      Swal.fire({
        title: 'รูปที่ครอปมีขนาดใหญ่เกินไป',
        html: 'ขนาด ' + formatMB(sizeBytes) + '<br>กรุณาใช้รูปที่มีขนาดไม่เกิน ' + MAX_MB + ' MB',
        icon: 'warning',
        confirmButtonText: 'ตกลง',
        confirmButtonColor: '#f5a623',
      });
    });
  });

  function observeHiddenOutputs() {
    document.querySelectorAll('input[type="hidden"].hidden-output').forEach(function (el) {
      cropperObserver.observe(el, { attributes: true, attributeFilter: ['value'] });
    });
  }
  observeHiddenOutputs();

  // รองรับกรณี cropper โหลด DOM ทีหลัง
  new MutationObserver(function () {
    observeHiddenOutputs();
  }).observe(document.body, { childList: true, subtree: true });

  // ตรวจซ้ำตอน submit — ป้องกันทุกกรณี
  document.addEventListener('submit', function (e) {
    const form = e.target;
    const hasFileInput    = form.querySelector('input[type="file"]');
    const hasCropperInput = form.querySelector('input[type="hidden"].hidden-output');
    if (!hasFileInput && !hasCropperInput) return;

    const errors = collectOversizedFiles(form);
    if (errors.length === 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    Swal.fire({
      title: 'ไม่สามารถบันทึกได้',
      html: 'ไฟล์ต่อไปนี้มีขนาดเกิน ' + MAX_MB + ' MB:<br><br>' + errors.join('<br>'),
      icon: 'error',
      confirmButtonText: 'ตกลง',
      confirmButtonColor: '#f5a623',
    });
  });
}
